import { render, staticRenderFns } from "./techos_secretarias_serie.vue?vue&type=template&id=149318dc&"
import script from "./techos_secretarias_serie.vue?vue&type=script&lang=ts&"
export * from "./techos_secretarias_serie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports